import { Design } from '../../../types';
import { importFromCsv } from '../file';
import { IntentLabelRow } from './get-intent-label-columns';

/** Get the labels to use in each language for each intent based on its name. */
export function getIntentLabels({
  csvData,
  rootSettings: { csvIntentLabelTableId }
}: Design): Map<string, IntentLabelRow> {
  const intentLabelCsv = (!csvIntentLabelTableId) ? null : (
    csvData.find(({ id }) => {
      return id === csvIntentLabelTableId;
    })
  )?.value;
  if (!intentLabelCsv) {
    return new Map();
  }

  return new Map<string, IntentLabelRow>(
    importFromCsv<IntentLabelRow>({
      text: intentLabelCsv
    }).map((row) => {
      return [row.Name, row];
    })
  );
}
